// @mui
import { Box, Stack } from '@mui/material';
// theme
import { hideScroll } from 'src/theme/css';
// components
import { NavSectionMini } from 'src/components/nav-section';

import { useSelector } from 'src/store';
//
import { HEADER, NAV } from '../config-layout';
import { useMiniNavData, useLockMiniNavData } from './config-navigation';
import { NavToggleButton } from '../_common';

// ----------------------------------------------------------------------

export default function NavMini() {
  const { isLoggedIn } = useSelector((state) => state.auth);
  const { name } = useSelector((state) => state.drawer);

  const navData = useMiniNavData();
  const lockNavData = useLockMiniNavData();

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_MINI },
        zIndex: name ? 1201 : 100,
        // zIndex: { lg: 1301, md: 1201 },
        backgroundColor: 'rgb(9 9 21)',
        // boxShadow: '0 .5rem 1rem rgba(0,0,0,.15)',
      }}
    >
      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: NAV.W_MINI,
          // borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          ...hideScroll.x,
        }}
      >
        <Stack
          justifyContent="center"
          alignItems="center"
          height={HEADER.H_MOBILE}
          borderBottom="1px solid #dfd7d729 !important"
        >
          <NavToggleButton />
        </Stack>

        <NavSectionMini
          data={isLoggedIn ? navData : lockNavData}
          config={{
            currentRole: 'admin',
          }}
          sx={{ paddingTop: 2 }}
        />
      </Stack>
    </Box>
  );
}
